import gql from 'graphql-tag';

const ADD_FAVORITE = gql`
  mutation addProductToFavorite($userId: ID!, $productId: ID!) {
    addProductToFavorite(userId: $userId, productId: $productId )
  }
`;

export default ADD_FAVORITE;